import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { createAdminModifier, deleteAdminModifier, fetchAdminModifiers, fetchAdminProductsLookup, updateAdminModifier, } from '@/api/adminCatalog';
import { parseApiErrorMessage } from '@/api/errors';
import { useAsyncData } from '@/hooks/useAsyncData';
import { AdminModal } from '@/pages/admin/ui/AdminModal';
import { AdminPageHeader } from '@/pages/admin/ui/AdminPageHeader';
import { useAdminToast } from '@/pages/admin/ui/AdminToast';
import { formatRub } from '@/pages/admin/ui/adminFormat';
export function ModifiersPage() {
    const { show } = useAdminToast();
    const [tick, setTick] = useState(0);
    const [editing, setEditing] = useState(null);
    const [name, setName] = useState('');
    const [price, setPrice] = useState('0');
    const [productIds, setProductIds] = useState([]);
    const [saving, setSaving] = useState(false);
    const list = useAsyncData(['admin-modifiers', tick], () => fetchAdminModifiers());
    const products = useAsyncData('admin-products-lookup', () => fetchAdminProductsLookup(), {
        enabled: editing != null,
    });
    const items = list.data ?? [];
    const openNew = () => {
        setEditing('new');
        setName('');
        setPrice('0');
        setProductIds([]);
    };
    const openEdit = (item) => {
        setEditing(item);
        setName(item.name);
        setPrice(String(item.price));
        setProductIds(item.productIds);
    };
    const toggleProduct = (id) => {
        setProductIds((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
    };
    const save = async () => {
        const priceNum = Number(price);
        if (!name.trim() || !Number.isFinite(priceNum) || priceNum < 0) {
            show('Укажите название и цену', 'warning');
            return;
        }
        setSaving(true);
        try {
            const body = { name: name.trim(), price: priceNum, productIds };
            if (editing === 'new')
                await createAdminModifier(body);
            else if (editing)
                await updateAdminModifier(editing.id, body);
            show('Сохранено');
            setEditing(null);
            setTick((n) => n + 1);
        }
        catch (err) {
            show(parseApiErrorMessage(err, 'Не удалось сохранить'), 'danger');
        }
        finally {
            setSaving(false);
        }
    };
    const remove = async (item) => {
        if (!window.confirm(`Удалить модификатор «${item.name}»?`))
            return;
        try {
            await deleteAdminModifier(item.id);
            show('Удалено');
            setTick((n) => n + 1);
        }
        catch (err) {
            show(parseApiErrorMessage(err, 'Не удалось удалить'), 'danger');
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(AdminPageHeader, { title: "\u041C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u044B", actions: _jsx("button", { type: "button", className: "admin-btn admin-btn-primary", onClick: openNew, children: "\u041D\u043E\u0432\u044B\u0439 \u043C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440" }) }), _jsx("div", { className: "admin-table-wrap", children: _jsxs("table", { className: "admin-table", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "ID" }), _jsx("th", { children: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435" }), _jsx("th", { children: "\u0426\u0435\u043D\u0430" }), _jsx("th", { children: "\u0422\u043E\u0432\u0430\u0440\u043E\u0432" }), _jsx("th", {})] }) }), _jsx("tbody", { children: items.map((item) => (_jsxs("tr", { children: [_jsx("td", { children: item.id }), _jsx("td", { children: item.name }), _jsx("td", { children: formatRub(item.price) }), _jsx("td", { children: item.productIds.length }), _jsx("td", { children: _jsxs("div", { className: "admin-btn-row", children: [_jsx("button", { type: "button", className: "admin-btn", onClick: () => openEdit(item), children: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C" }), _jsx("button", { type: "button", className: "admin-btn admin-btn-danger", onClick: () => void remove(item), children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" })] }) })] }, item.id))) })] }) }), !list.loading && items.length === 0 ? _jsx("p", { className: "admin-empty", children: "\u041F\u043E\u043A\u0430 \u043D\u0435\u0442 \u043C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u043E\u0432" }) : null, _jsxs(AdminModal, { open: editing != null, title: editing === 'new' ? 'Новый модификатор' : 'Модификатор', onClose: () => setEditing(null), footer: _jsxs(_Fragment, { children: [_jsx("button", { type: "button", className: "admin-btn", onClick: () => setEditing(null), children: "\u041E\u0442\u043C\u0435\u043D\u0430" }), _jsx("button", { type: "button", className: "admin-btn admin-btn-primary", disabled: saving, onClick: () => void save(), children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" })] }), children: [_jsxs("div", { className: "admin-field", children: [_jsx("label", { htmlFor: "mod-name", children: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435" }), _jsx("input", { id: "mod-name", className: "admin-input", value: name, onChange: (e) => setName(e.target.value) })] }), _jsxs("div", { className: "admin-field", children: [_jsx("label", { htmlFor: "mod-price", children: "\u0426\u0435\u043D\u0430, \u20BD" }), _jsx("input", { id: "mod-price", className: "admin-input", type: "number", min: 0, value: price, onChange: (e) => setPrice(e.target.value) })] }), _jsxs("div", { className: "admin-field", children: [_jsx("span", { children: "\u0422\u043E\u0432\u0430\u0440\u044B" }), _jsx("div", { className: "admin-check-list", children: (products.data ?? []).map((product) => (_jsxs("label", { className: "admin-check", children: [_jsx("input", { type: "checkbox", checked: productIds.includes(product.id), onChange: () => toggleProduct(product.id) }), "#", product.id, " ", product.name] }, product.id))) })] })] })] }));
}
